<template>
    <div class="page-container md-layout-row" v-if="settmenu.length">
      <md-app>
        <md-app-drawer md-permanent="full">
          <md-toolbar class="md-transparent toolbar-setting" style="color: #797979;" md-elevation="0">
            SETTINGS
          </md-toolbar>
          <md-list style="background-color: #fff;">
            <md-list-item v-for="item in settmenu" :key="item.id" :to="item.link">
              <i class="md-icon">{{item.icon}}</i>
              <span class="md-list-item-text">{{item.label}}</span>
            </md-list-item>
          </md-list>
        </md-app-drawer>
        <md-app-content class="content-myacc">
          setting-about
        </md-app-content>
      </md-app>
    </div>
</template>
<script>
  export default {
    name: 'setting-about',
    computed: {
      settmenu (){
        return this.$store.getters['menu/settmenu']
      },
    },
  }
</script>